<app-common-modal-form
  icon="ic-edit-20"
  header="Edit Document Settings"
  confirmText="Save"
  closeText="Cancel"
  [formGroup]="form"
  [isLoading]="isLoading"
  [isInvalid]="form.invalid || isInvalidSaveButton"
  (confirm)="confirm()"
  (close)="close()"
>
  <div class="edit-document-settings-modal-body">
    <div class="documents-part">
      <div class="part-title">eSigning</div>
      <div class="part-body">
        <app-select
          label="Receive email for eSigned documents. Select recipient(s) from the list"
          formControlName="receiveEmailsForDocs"
          [options]="NotifyWhenAllPartiesSignedDocumentOptions"
          [valuePrimitive]="true"
        />
      </div>
    </div>

    <div class="annual-statement-part">
      <div class="part-title">Annual Statement</div>

      <div class="part-body">
        <app-yes-no-control
          label="Do you want to generate an annual statement automatically?"
          formControlName="generateAutomatically"
        />

        <app-yes-no-control
          label="Do you want to add Director's Signature to the Company Statement?"
          formControlName="addSignatoryToCompanyStatement"
        />

        <app-radio
          label="Choose the type of document to generate"
          controlId="document-type-to-generate"
          [options]="DocumentTypeToGenerateOptions"
          [(ngModel)]="this.form.value.documentTypeToGenerate"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onDocumentationTypeChange()"
        />

        <app-select
          label="Meeting type"
          formControlName="meetingLocationType"
          [options]="MeetingLocationTypeOptions"
          [valuePrimitive]="true"
          (ngModelChange)="onMeetingAddressTypeSelect($event)"
        />

        @if (form.controls.meetingLocationType.value === MeetingLocationType.Other) {
          <div>
            <app-address-form-group
              [formGroup]="form.controls.otherAddress"
              [expandedAddressForm]="false"
              [isDisabled]="form.controls.meetingLocationType.value !== MeetingLocationType.Other"
              [addressStatus]="addressStatus"
              (onDataStatusChange)="onDataStatusChange($event)"
            />
          </div>
        }

        @if (form.controls.meetingLocationType.value === MeetingLocationType.Online) {
          <div>
            <app-select
              label="Meeting online type"
              formControlName="meetingOnlineType"
              [options]="MeetingOnlineTypeOptions"
              [valuePrimitive]="true"
            />
          </div>
        }

        <app-document-selection
          title="Documents to Generate"
          controlId="document-selection-checkbox"
          [documentSelectionList]="form.value.documentSelectionFiles!"
          [documentationType]="form.value.documentTypeToGenerate!"
          [isDisabled]="false"
          (documentSelectionChange)="onDocumentSelectionChange($event)"
        />
      </div>
    </div>
  </div>
</app-common-modal-form>
